import React, { useState, useEffect } from 'react';
import { formatMoneda } from '../../../util/varios';
import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material'

;

import useTableFijo from "../../useTableFijo"
import moment from 'moment';


const TablaDeudaApuesta = props => {

    let op = require('../../../../src/modulos/datos');

    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar, setMostrar] = useState(false);
    const [mostrar3, setMostrar3] = useState(false);
    const [mostrar4, setMostrar4] = useState(false);
    const [deuda, setDeuda] = useState();
    const [interes, setInteres] = useState();
    const [recargo, setRecargo] = useState();
    const [multa, setMulta] = useState();
    const [totDeuda, setTotDeuda] = useState();


    const [records, setRecords] = useState([]);

    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });

    const headCells = [
        { id: 'anio', label: 'AÑO', width: '10px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white", disableSorting: true },
        { id: 'mes', label: 'MES', width: '80px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white", disableSorting: true },
        { id: 'mondeu', label: 'MONTO', width: '150px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white", disableSorting: true },
        { id: 'intmoradeu', label: 'INTERES MORA', width: '150px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white", disableSorting: true },
        { id: 'multa', label: 'MULTAS', width: '150px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white", disableSorting: true },
        { id: 'recargodeu', label: 'RECARGOS', width: '150px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white", disableSorting: true },
    ];

    let heightTabla = 320;

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableFijo(records, headCells, filterFn, heightTabla);

    
    useEffect(() => {

        
        if (props.tabdeuda) {
            let deu = parseFloat(0.00);
            let inte = parseFloat(0.00);
            let reca = parseFloat(0.00);
            let mul = parseFloat(0.00);
            for (let i = 0; i < props.tabdeuda.length; i++) {
                deu = deu + parseFloat(props.tabdeuda[i].monto);
                inte = inte + parseFloat(props.tabdeuda[i].intereses);
                reca = reca + parseFloat(props.tabdeuda[i].recargo);
                mul = mul + parseFloat(props.tabdeuda[i].multa);
            }

            setDeuda(formatMoneda(deu.toString().replace('.', ','), ',', '.', 2));
            setInteres(formatMoneda(inte.toString().replace('.', ','), ',', '.', 2));
            setRecargo(formatMoneda(reca.toString().replace('.', ','), ',', '.', 2));
            setMulta(formatMoneda(mul.toString().replace('.', ','), ',', '.', 2));
            setTotDeuda(formatMoneda((deu + inte + reca + mul).toString().replace('.', ','), ',', '.', 2));
            setRecords(props.tabdeuda);

        }


    }, [props.tabdeuda]);

    const imprimirDeudaGeneral = ()/*  => (event) */ => {
        /* event.preventDefault(); */
    
          var reporte ='EdoCtaCorto2Com';
          var idcomercio = props.idcomercio;
            /* /siap?reporte=Planillacontricomercio&id=79&tipo=(2,34,69) */
            let fechasistema = JSON.parse(localStorage.getItem('fechasistema'));
            let espiritu = JSON.parse(localStorage.getItem('espiritu'));
    
            window.open(op.reportes + "/actividadeconomica?" + "reporte=" + reporte + "&id=" + idcomercio + "&fecha=" + moment.utc(fechasistema).format('YYYY/MM/DD')+ "&espiritu=" + espiritu , "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
        }

    return (
        <div className="card">
            <div className="card-body" style={{ height: "100%", backgroundColor: 'rgb(14, 86, 148)' }}>
                <div className="content" >
                    <div className="container">
                        <div className="row col-md-12" style={{ height: "100%" }}>
                            <div className="row" >
                                <div className="col-md-9">
                                    <TblContainer >
                                        <TblHead />

                                        <tbody>
                                            {

                                                records && records.map((item, index) => (
                                                    <tr key={item.anio + item.mes} style={{ padding: "0" }}>
                                                        <td style={{ fontSize: "10px", textAlign: "left" }}>{item.anio}</td>
                                                        <td style={{ fontSize: "10px", textAlign: "left" }}>{item.mes}</td>
                                                        <td style={{ fontSize: "10px", textAlign: "right" }}>{formatMoneda(item.monto.toString().replace('.', ','), ',', '.', 2)}</td>
                                                        <td style={{ fontSize: "10px", textAlign: "right" }}>{formatMoneda(item.intereses.toString().replace('.', ','), ',', '.', 2)}</td>
                                                        <td style={{ fontSize: "10px", textAlign: "right" }}>{formatMoneda(item.multa.toString().replace('.', ','), ',', '.', 2)}</td>
                                                        <td style={{ fontSize: "10px", textAlign: "right" }}>{formatMoneda(item.recargo.toString().replace('.', ','), ',', '.', 2)}</td>
                                                    </tr>

                                                ))
                                            }
                                        </tbody>

                                    </TblContainer>
                                </div>
                                <div className="row col-md-3">

                                    <button style={{ marginBottom: "10px", margin: "auto" }} onClick={imprimirDeudaGeneral} className="btn btn-primary"><i className="fas fa-print"> Imprimir </i> </button>

                                    <div className="col-md-12">
                                        <div className="row">
                                            <div className="col-md-8">
                                                <label htmlFor="inputRitm">Deuda: </label>
                                            </div>
                                            <div className="col-md-4" style={{ textAlign: "right" }}>
                                                <label htmlFor="inputRitm">{deuda}</label>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-8">
                                                <label htmlFor="inputRitm">Intereses de Mora: </label>
                                            </div>
                                            <div className="col-md-4" style={{ textAlign: "right" }}>
                                                <label htmlFor="inputRitm">{interes}</label>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-8">
                                                <label htmlFor="inputRitm">Recargo por Mora: </label>
                                            </div>
                                            <div className="col-md-4" style={{ textAlign: "right" }}>
                                                <label htmlFor="inputRitm">{recargo}</label>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-8">
                                                <label htmlFor="inputRitm">Multa: </label>
                                            </div>
                                            <div className="col-md-4" style={{ textAlign: "right" }}>
                                                <label htmlFor="inputRitm" style={{ textAlign: "right" }} >{multa}</label>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-8">
                                                <label htmlFor="inputRitm">Total de la Deuda: </label>
                                            </div>
                                            <div className="col-md-4" style={{ textAlign: "right" }}>
                                                <label htmlFor="inputRitm" style={{ textAlign: "right" }}>{totDeuda}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12" style={{ textAlign: "center", marginTop: "20px" }}>
                                    <div className="col-md-12">
                                        <label htmlFor="inputRitm" style={{ fontSize: "16px" }}> &nbsp; </label>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label htmlFor="inputRitm" style={{ fontSize: "16px" }}> &nbsp; </label>
                                        </div>
                                        <div className="col-md-2">
                                            <label htmlFor="inputRitm" style={{ fontSize: "16px", fontWeight: "bold" }}>Crédito a Favor: </label>
                                        </div>
                                        <div className="col-md-2">
                                            <label htmlFor="inputRitm" style={{ fontSize: "16px", textAlign: "right", fontWeight: "bold" }}>{/* {props.credito !== null ? formatMoneda(props.credito.toString().replace('.', ','), ',', '.', 2) : '0,00'} */}</label>
                                        </div>
                                        <div className="col-md-4">
                                            <label htmlFor="inputRitm" style={{ fontSize: "16px" }}> &nbsp; </label>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );

}

export default TablaDeudaApuesta;
